import RankedAPI from "@api/lol/Ranked.api";
import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Modal, Text } from "@mantine/core";
import type { ILoLAccount } from "@modules/ranked/models/IRankedSmurf.models";
import useRankedDetailsModalStore from "@store/rankedDetails.store";
import { useEffect, useState } from "react";
import { RankDetails } from "./components/RankDetails";
import { SkinsAndChampionsPreview } from "./components/SkinsAndChampionsPreview";

const RankedDetailsModal: React.FC = () => {
  const [account, setAccount] = useState<ILoLAccount | undefined>();
  const { isOpened, close, puuid } = useRankedDetailsModalStore();
  const { t } = useAppTranslation("pages.ranked.rankedDetails");

  useEffect(() => {
    if (!puuid) return undefined;

    RankedAPI.get(puuid).then((res) => setAccount(res.data));
  }, [puuid]);

  return (
    <Modal
      classNames={{
        content: "gradient-blue-purple p-[1px] overflow-hidden flex flex-col",
        header:
          "bg-primary-default border-b-2 border-primary-lighter py-4 px-6",
        body: "bg-primary-default p-0 rounded-b-2xl flex-1 overflow-hidden h-full flex",
        close: "default-icon",
      }}
      radius={15}
      opened={isOpened}
      size="auto"
      title={
        <Group wrap="nowrap">
          <AppThemeIcon className="size-5">
            <Icon.Info />
          </AppThemeIcon>
          <Text className="font-extrabold text-2xl text-primary-white">
            {t("modalTitle")}
          </Text>
        </Group>
      }
      centered
      onClose={close}
    >
      <div className="mx-8 flex-1 overflow-x-hidden overflow-y-scroll">
        {account && (
          <Group className="flex-wrap pt-5 pb-6 xl:flex-nowrap">
            <RankDetails account={account} />

            <SkinsAndChampionsPreview
              champions={account.champions}
              permanentSkins={account.skins.filter((s) => !s.pivot_is_shard)}
              skinShards={account.skins.filter((s) => s.pivot_is_shard)}
            />
          </Group>
        )}
      </div>
    </Modal>
  );
};

export default RankedDetailsModal;
